import React from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  /** Big block commented out incase we bring back left stacked mobile price */
  vendor?: {
    vendorName: string;
    rateDisplayOption: {
      showPkgPriceOnly: boolean;
    };
  };
  /** should unit price be shown */
  showPricing: boolean;
  /** method to retrieve the price value */
  getPriceString: () => string;
  /** method to trigger edit modal */
  editItem: (item: any) => void;
  /** remove item button method */
  removeItem: (item: any) => void;
  /** item to be edited or removed */
  item: any;
}

const MobileUnitPriceEditDelete: React.FC<Props> = ({
  vendor,
  showPricing,
  getPriceString,
  editItem,
  removeItem,
  item,
}) => {
  return (

    /** {Left-Justified Variant} may need to modify the css file for width
     <div className="flex-direction-row d-flex w-100">
      <Col xs={4} className="pl-0 pt-2">
        <p className="m-0 p-0 text-left font-weight-bold green-text">
          {!vendor?.rateDisplayOptions.showPkgPriceOnly && showPricing ? getPriceString() : "Package Price"}
        </p>
      </Col>
      <Col xs={8} style={{ textAlign: 'end', marginTop: '5px' }}>
        <Button
          size="sm"
          className="mobile-edit"
          onClick={() => editItem(item)}
        >
          Edit
        </Button>
        <Button
          size="sm"
          className="mobile-remove"
          onClick={() => removeItem(item)}
        >
          Remove
        </Button>
      </Col>
    </div>
    */
   /** {Right-Justified Variant} may need to modify the css file for width
    <div className="d-flex">
      <Button
        size="sm"
        className="mobile-edit"
        onClick={() => editItem(item)}
      >
        Edit
      </Button>
      <Button
        size="sm"
        className="mobile-remove"
        onClick={() => removeItem(item)}
      >
        Remove
      </Button>
    </div> */
    /** {Icons: split horizontally Variant}
    <div className="d-flex">
      <Button
        size="sm"
        className="mobile-edit"
        onClick={() => editItem(item)}
      >
       <i className="fa fa-pencil-alt" aria-hidden="true"/>
      </Button>
      <Button
        size="sm"
        className="mobile-remove"
        onClick={() => removeItem(item)}
      >
        <i className="fa fa-trash"/>
      </Button>
    </div>*/
    /** {Icons: split vertically Variant} */
    <div style={{alignItems: 'end', display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between'}}>
      <Button
        size="sm"
        className="mobile-remove"
        onClick={() => removeItem(item)}
      >
        <i className="fa fa-trash"/>
      </Button>
      <p className="font-weight-bold green-text" style={{fontSize: '13px', margin: 0}}>
        {!vendor?.rateDisplayOption.showPkgPriceOnly && showPricing ? getPriceString() : "Package Price"}
      </p>
      <Button
        size="sm"
        className="mobile-edit"
        onClick={() => editItem(item)}
      >
       <i className="fa fa-pencil-alt"/>
      </Button>
    </div>
  );
};

export default MobileUnitPriceEditDelete;